import classNames from 'classnames';
import _ from 'lodash';
import React from 'react';
import { createUseStyles } from 'react-jss';
import { useSpotAPI } from '../../apis/spot-api';
import { Feature, useFeature } from '../../hooks/use-feature';
import { useStorage } from '../../hooks/use-storage';
import { layoutDefaults } from '../../utils/layout-defaults';
import { parseCategoryClassId } from '../../utils/manager/category-manager';
import { useCartWorkflow } from '../../workflow/cart-workflow';
import '../custom-bootstrap.css';
import { AccountButton } from './account-button';
import { Category } from './category';
import { Mosaic } from './mosaic';

// const scrollSpeed = 200;

function Body({ categories, setUpdating }) {
  const { setSpot, orders } = useStorage();
  const { isFeatureEnabled } = useFeature();
  const { loadSpotFromRemote } = useSpotAPI();
  const { prepareCartWorkflow, showCartWorkflow } = useCartWorkflow();
  const classes = useStyles();

  const scrollToCategory = (category) => {
    if (category != null) {
      const classId = `.${parseCategoryClassId(category)}`;
      // eslint-disable-next-line no-undef
      const dest = document.querySelector(classId);

      setTimeout(() => {
        // document.querySelector('html').animate(
        // eslint-disable-next-line no-undef
        window.scrollTo(
          0,
          dest.offsetTop + layoutDefaults.smallerVerticalMargin
        );
      }, 400);
    }
  };

  const onClickGoBack = () => {
    setTimeout(() => {
      // eslint-disable-next-line no-undef
      window.scrollTo(0, 0);
      // document.querySelector('html').animate(
      //   {
      //     scrollTop: 0,
      //   },
      //   {
      //     duration: scrollSpeed,
      //     easing: 'linear',
      //   }
      // );
    }, 300);
  };

  const onSpotChange = async (newSpot) => {
    const lSpot = await loadSpotFromRemote(newSpot.id);
    setSpot(lSpot);
  };

  return (
    <div className={classes.container}>
      {/* <TempBanner /> */}

      {categories?.length > 1 && (
        <Mosaic categories={categories} onSelect={scrollToCategory} />
      )}
      {categories?.map((category) => (
        <Category
          key={category.id}
          data={category}
          setUpdating={setUpdating}
          prepareCartWorkflow={prepareCartWorkflow}
          showCartWorkflow={showCartWorkflow}
          onClickGoBack={onClickGoBack}
          onSpotChange={onSpotChange}
          // row={index + 1}
          // totalRows={categories?.length ?? 0}
        />
      ))}

      {isFeatureEnabled(Feature.SELF_ORDERING) && !_.isEmpty(orders) && (
        <div className={classNames(classes.fixedContainer, 'd-grid')}>
          <AccountButton
            // updating={updating}
            setUpdating={setUpdating}
          />
        </div>
      )}
    </div>
  );
}

const useStyles = createUseStyles({
  container: {
    // border: '1px solid green',
    fontSize: layoutDefaults.fontSize,
  },
  // iconsContainer: {
  //   display: "flex",
  //   position: "fixed",
  //   top: 0,
  //   left: 0,
  //   opacity: 0.4,
  //   zIndex: 100,
  //   marginLeft: layoutDefaults.horizontalMargin,
  //   // border: '1px solid green',
  // },
  icon: {
    top: 0,
    marginTop: `max(${layoutDefaults.verticalMargin}px, env(safe-area-inset-top))`,
    marginRight: layoutDefaults.smallHorizontalMargin,
    // marginRight: 40,
    cursor: 'pointer',
    // border: '1px solid red',
  },
  fixedContainer: layoutDefaults.fixedContainer,
  // fixedButton: {
  //   opacity: 1,
  // },
});

export { Body };
